import { Box, styled, Typography, Chip } from "@mui/material";
import StopIcon from "@mui/icons-material/Stop";
import { brighthiveTheme } from "../../../theme/theme";

export const MainContainer = styled(Box)({
  display: "flex",
  flexDirection: "column-reverse",
  flex: "1 1 0",
  overflowY: "auto",
});

export const SubMainContainer = styled(Box)({
  maxWidth: "890px",
  width: "100%",
  boxSizing: "border-box",
  margin: "0 auto",
  paddingBottom: "1rem",
  paddingX: "1.5rem",
});

export const LoadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});

export const StyledEditorWrapper = styled(Box)`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
`;

export const EditorContainer = styled(Box)`
  max-width: 890px;
  margin: 0 auto;
  padding-inline: 1.5rem;
`;

export const ReasoningTagContainer = styled(Box)({
  display: "flex",
  paddingTop: "8px",
});

export const ReasoningTag = styled(Chip)<{ active?: boolean }>`
  cursor: pointer;
  background-color: ${({ active }) =>
    active
      ? brighthiveTheme.palette.primary.main
      : brighthiveTheme.palette.grey[200]};
  color: ${({ active }) =>
    active
      ? brighthiveTheme.palette.primary.darkest
      : brighthiveTheme.palette.text.secondary};
  border: 1px solid
    ${({ active }) =>
      active
        ? brighthiveTheme.palette.primary.main
        : brighthiveTheme.palette.grey[300]};
  transition: all 0.2s ease-in-out;
  font-size: 13px;
  font-weight: 500;

  &:hover {
    background-color: ${({ active }) =>
      active
        ? brighthiveTheme.palette.primary.contrastText
        : brighthiveTheme.palette.grey[300]};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .MuiChip-icon {
    color: ${({ active }) =>
      active
        ? brighthiveTheme.palette.primary.darkest
        : brighthiveTheme.palette.text.secondary};
    margin-right: ${({ active }) => (active ? "0px" : "-4px")};
    font-size: 16px;
  }

  .MuiChip-label {
    padding-left: 4px;
  }
`;

export const StyledStopIcon = styled(StopIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  height: "2rem !important",
  width: "2rem !important",
}));

export const ChatBotWidgetDescription = styled(Typography)`
  color: ${brighthiveTheme.palette.gray.darkest};
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.25px;

  &.black {
    color: ${brighthiveTheme.palette.common.black};
  }
`;

export const ChatBotWrapper = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  &.grow-1 {
    flex-grow: 1;
  }
`;

export const Time = styled(Typography)`
  color: ${brighthiveTheme.palette.action.disabled};
  font-size: 12px;
  font-weight: 500;

  &.positioned {
    line-height: 1.5;
    position: absolute;
    right: 12px;
    top: 16px;
  }
`;

export const AvatarWrapper = styled(Box)`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  color: ${brighthiveTheme.palette.grayAccent.contrastText};
  border: 1px solid ${brighthiveTheme.palette.custom.outline};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  line-height: 0;
  font-size: 0;
  padding: 3px 2px 0;

  &.positioned {
    position: absolute;
    left: 0;
    top: 0;
  }

  &.success {
    position: relative;
    border-color: ${brighthiveTheme.palette.success.lighter};

    img,
    svg {
      width: 80%;
      height: 80%;
    }
  }

  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
    vertical-align: top;
  }
`;

export const StyledPromptGuideContainer = styled(Box)`
  display: flex;
  justify-content: center;
  margin: 0.3rem 0;
`;
